import { useCustomerHook } from '../../[id]/get/get-customer';

/**
 * @deprecated
 * Use "useIdentify" from '@hungryroot/customer' instead
 */
export function useCustomerSelf(
  query?: Record<string, string | number | boolean | string[]>
) {
  return useCustomerHook('self', query ?? {});
}
